import { DEBUG_MODE, HOST } from './config'

export const GET_ARTISTS_CALLSTRING: string[] = [
  `self.addEventListener('message', async (event) => {
      if (event.data != undefined && event.data != null && event.data.toString().trim() != '') {
        try {
          const opts = {
            method: 'GET',
            cache: 'force-cache',
          }
          await fetch('${HOST}' + '/api/p.stream-sv/ba/gba', opts)
            .then(async (x) => {
              const ret = await x.json()
              self.postMessage(ret?.artists)
            })
            .catch((e) => {
              if (${DEBUG_MODE}) console.log(e)
              self.postMessage([])
            })
        } catch (e) {
          if (${DEBUG_MODE}) console.log(e)
          self.postMessage([])
        }
      } else self.postMessage([])
    })`,
]
